import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { EntInitialFilterName } from "../../models/filters/initialFilterName";
import { getCookie } from "typescript-cookie";
import { EntDepartment } from "../../models/handBooks/department";
import { useLazyGetDepartmentListQuery } from "../../redux/api/handBooksApi/departmentsApi";

interface IProps {
    value?: number | null;
    onChange?: (v: number) => void;
    governmentIds?: number[] | null;
}

const SelectMultiDepartment = (props: IProps) => {
    const { t } = useTranslation();
    const [options, setOptions] = useState<ISelectOption[]>([]);

    const [getData] = useLazyGetDepartmentListQuery();
    const {
        fetching,
        data,
        setData,
        setFetching,
        setFilter,
        scrollHandler,
        setCurrentPage
    } = useGetDataOnScroll<EntDepartment, EntInitialFilterName>({
        initialFilter: new EntInitialFilterName(),
        query: getData
    });
    useEffect(() => {
        if (props.governmentIds) {
          const filter = new EntInitialFilterName();
          filter.governmentIds = props.governmentIds;
          setFilter(filter);
          setData([]);
          setCurrentPage(0);
          setFetching(true);
        } else {
          setOptions([]);
          setData([]);
        }
      }, [props.governmentIds]);
    useEffect(() => {
        const optionss = Array.from(new Set(data)).map((a) => {
            return { label: getCookie('i18next') === 'ky' ? `${ a.nameKy }` : `${ a.nameRu }`, value: a.id ?? '' };
        });
        setOptions(optionss);
    }, [data]);

    const search = (value?: string) => {
        if (!value) return;
        const filter = new EntInitialFilterName();
        filter.name = value;
        setFilter(filter);
        setData([]);
        setCurrentPage(0);
        setFetching(true);
    }
    const clear = () => {
        const filter = new EntInitialFilterName();
        filter.name = null;
        setFilter(filter);
        setData([]);
        setCurrentPage(0);
        setFetching(true);
    }
    return (
        <Select
            mode="multiple"
            placeholder={ t("msg.selectPlaceholder") }
            onClear={ clear }
            onSearch={ search }
            onPopupScroll={ scrollHandler }
            loading={ fetching }
            value={ props.value }
            onChange={ props.onChange }
            options={ options }
            filterOption={ defaultFilterOption }
            showSearch
            allowClear
            dropdownRender={ (menu) => (
                <Spin spinning={ fetching }>
                    { menu }
                </Spin>
            ) }
        />
    );
};

export default SelectMultiDepartment;
